import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { PhotoStrip } from "@/components/landing/PhotoStrip";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { DevisForm } from "@/components/landing/DevisForm";
import { Steps } from "@/components/landing/Steps";
import { ProofFooter } from "@/components/landing/ProofFooter";

export default function Landing() {
  return (
    <div className="bg-[#0A1628] text-[#e2e8f0] min-h-screen font-body antialiased overflow-x-hidden selection:bg-[#51ADDA] selection:text-[#0A1628]">
      <Nav />
      <Hero />
      <PhotoStrip />
      <Marquee />
      <Services />
      <DevisForm />
      <Steps />
      <ProofFooter />
    </div>
  );
}
